import { Radio } from "components/ui"
import { formatCurrency } from "utils/helpers"

export const ProductCard = ({ product, single = false, onClick, selected = false }) => {
    if (!product) return <></>

    return (
        <div className={`grid grid-cols-5 w-full items-center mb-2 py-2 gap-9 ${selected ? "bg-red-600" : "bg-custom-900"} px-4 rounded-lg`}>
            <div className="flex flex-col col-span-2 py-2">
                <span className={`text-sm font-semibold ${selected ? "text-white" : "text-black"}`}>{product.name}</span>
            </div>

            <span className="text-sm font-semibold w-full text-right">{product.duration_months ? `${product.duration_months} Months` : 'N\\A'}</span>
            <span className={`text-sm font-semibold ${selected ? "text-white" : "text-black"}`}>
                {formatCurrency(product.price)}
            </span>

            {!single && (
                <div className="flex justify-end items-center col-span-1">
                    {selected ? (
                        <div className="px-3">
                            <Radio
                                color="white"
                                onChange={() => onClick(product.id)}
                                defaultChecked={selected}
                            >
                            </Radio>
                        </div>
                    ) : (
                        <button
                            onClick={() => onClick(product.id)}
                            className={`hover:bg-custom-100 text-sm text-black font-bold rounded-md py-2 px-4 w-fit`}>
                            <i className="fas fa-arrow-right"></i>
                        </button>
                    )}

                </div>
            )}

            {/* <div className="flex flex-col items-center w-full h-auto text-black gap-6">
                <div className={`flex justify-between w-full`}>
                    <div className="flex flex-col w-full">
                        <span className="text-lg font-normal">{product.name}</span>
                    </div>

                    <div className="flex w-full justify-end items-start">
                        <div className="flex flex-col">
                            <span className="text-xl font-normal">
                                {formatCurrency(product.price)}
                            </span>
                        </div>

                        {!single && (
                            <div className="ml-5 flex flex-col">
                                <button
                                    onClick={() => onClick(product.id)}
                                    className={` ${selected ? "bg-custom-300" : "bg-custom-100 hover:bg-custom-300"} text-xs text-white font-bold py-2 px-4 rounded-full`}>
                                    {selected ? "Remove" : "Select"}
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                <div className="flex w-full gap-8 items-center  text-black dark:text-gray-300">
                    <span className="text-md">
                        <i className="fas fa-coins mr-2 text-black font-bold"></i>
                        Excess: <span className="text-black ml-2 font-bold">{formatCurrency(product.excess)}</span></span>
                    <span className="text-md">
                        <i className="fas fa-money-bill mr-2 text-black font-bold"></i>
                        Payment: <span className="text-black ml-2 font-bold">{formatCurrency(product.price)}</span></span>
                    <span className="text-md">
                        <i className="fas fa-calendar mr-2 text-black font-bold"></i>
                        Duration: <span className="text-black ml-2 font-bold">{product.duration_months ? `${product.duration_months} Months` : 'N\\A'}</span></span>
                </div>
            </div> */}
        </div>
    )
}